// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"f80d5412","453":"33913999","454":"ccd875ad","648":"1cefbbd5","667":"040e3c6b","776":"381ed347","817":"401870eb"}[chunkId] + ".chunk.js";
};